<template>
    <transition name="fade">
        <div class="cookie-consent-container" v-if="isVisible">
            <div class="cookie-consent">
                <div class="cookie-consent-header" data-nosnippet>
                    Cookie Settings
                </div>
                <div class="cookie-consent-body">
                    <div class="cookie-consent-text" data-nosnippet v-html="policyText"></div>
                    <div class="cookie-consent-actions" data-nosnippet>
                        <a class="button" @click="reject()">Opt Out</a>
                        <a class="button primary-button" @click="accept()">Accept</a>
                    </div>
                </div>
            
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        isCookieStatusSet: {
            type: Boolean,
            default: false,
        },
        domain: {
            type: String,
            default: null,
        },
        policyText: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isVisible: false,
        }
    },
    methods: {
        accept() {
            this.setCookie('analytics', 'enabled')
            this.hide()
        },
        reject() {
            this.setCookie('analytics', 'disabled')
            this.hide()
        },
        setCookie(name, value, domain) {
            let cookie = "cookieconsent_" + name + "_status=" + value + "; expires=" + this.nextYear + "; path=/;";

            if (this.domain) {
                cookie = cookie + " domain=" + this.domain;
            }

            document.cookie = cookie
        },
        show() {
            this.isVisible = true
        },
        hide() {
            this.isVisible = false
        },
    },
    computed: {
        nextYear() {
            const date = new Date()
            const nextFullYear = date.getFullYear() + 1
            
            date.setFullYear(nextFullYear)

            return date.toUTCString()
        },
    },
    mounted() {
        if (! this.isCookieStatusSet) {
            this.show()
        }
    }
}
</script>

<style lang="scss">
    $font-family: 'Exo 2', sans-serif;

    .cookie-consent-container {
        position: fixed;
        left: 0;
        bottom: 0;
        display: flex;
        font-family: $font-family; 
        max-width: 100vw;
        width: 360px;
        z-index:1000;


        .button {
            display: flex;
            height: 44px;
            width: 128px;
            border-style: solid;
            border-width: 2px;
            border-color: var(--tertiary-color-light-5);
            align-items: center;
            justify-content: center;
            margin: 0 6px;
            cursor: pointer;
            background-color:#FFF;
            color: var(--tertiary-color);
        }

        .primary-button {
            background-color: var(--tertiary-color-light-5);
            color: white;

            &:hover {
                border-color: var(--tertiary-color);
                background-color: var(--tertiary-color);
            }
        }

        .secondary-button {
            color: var(--tertiary-color);
            border-color: var(--tertiary-color);
        }

        .fade-enter-active, .fade-leave-active {
            transition: opacity .5s;
        }

        .fade-enter, .fade-leave-to {
            transition: opacity .3s;
            opacity: 0;
        }
    }

    .cookie-consent {
        border: 2px solid var(--tertiary-color-light-5);
        border-radius: 4px;
        box-shadow: 0 20px 25px -5px rgba(0,0,0,.1),0 10px 10px -5px rgba(0,0,0,.04);
        margin-bottom: 24px;
        margin-left: 24px;
        margin-right: 24px;
        background-color: #FFF;

        @media only screen and (max-width: 600px) {
            margin-bottom: 16px;
            margin-left: 16px;
            margin-right: 16px;
        }
    }

    .cookie-consent-header {
        background: var(--tertiary-color-light-5);
        padding: 10px 0;
        color: white;
        margin: 0;
        text-align: center;
        font-size: 18px;
    }

    .cookie-consent-body {
        padding: 32px;

        @media only screen and (max-width: 600px) {
            padding: 24px;
        }
    }

    .cookie-consent-text {
        margin-bottom: 24px;
        line-height: 22px;
        font-size: 16px;
        
        a {
            font-weight: 600;
            text-decoration: underline;
            color: var(--tertiary-color-light-5);

            &:hover {
                color: var(--tertiary-color);
            }
        }
    }   

    .cookie-consent-actions {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
    }
</style>